module.exports = __webpack_public_path__ + "img/treaty.490fd75f.png";